import { useCorePermissions } from "spark-core-dx/hooks"
import { DashMessage } from "./DashMessage"
import { useDashboardDomainContext } from "../../../DashboardDomainProvider";

export const WelcomeMessage = () => {
    const { canEdit } = useCorePermissions();
    const { navigateToDashboardList } = useDashboardDomainContext();
    return (
        <DashMessage
            icon={"dashboard"}
            title={"Dashboard Workspace"}
            description={
                canEdit('Dashboard') ?
                    "Choose a dashboard to start working with pages."
                    :
                    "Select a dashboard to get started."

            }
            buttonText={"Choose Dashboard"}
            onClick={navigateToDashboardList}
        />
    )
}
